import { compact, path } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toTextFromProp } from '../../fields/text';

export const deprecatedDownloadLink = ({ primary }) =>
  compact({
    type: CommonSliceType.DOWNLOAD_LINK,
    label: toTextFromProp('label', primary),
    url: path('link.url', primary),
    weight: path('link.size', primary),
    linkType: 'download',
  });

export const downloadLink = ({ items }) => {
  return compact({
    type: CommonSliceType.DOWNLOAD_LINK,
    label: toTextFromProp('title', items?.[0]),
    url: path('link.url', items?.[0]),
    weight: path('link.size', items?.[0]),
    linkType: 'download',
  });
};
